export const FOOTER_HEIGHT = 147;
